import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

import { Pagination } from "swiper";
import { Book } from "./Book";

export const SwiperComp = ({ books }) => {
  return (
    <div className="mt-10 mx-4 mb-5 sm:mx-0">
      <Swiper
        centeredSlides={false}
        pagination={{
          clickable: true,
        }}
        modules={[Pagination]}
        className="mySwiper"
        breakpoints={{
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 1.8,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1440: {
            slidesPerView: 4,
            spaceBetween: 25,
          },
          1700: {
            slidesPerView: 5,
            spaceBetween: 25,
          },
        }}
      >
        {books?.map((book) => (
          <SwiperSlide key={book.id}>
            <Book book={book} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
